<template>
    <div class="main_container">
        <div class="search-box" id="searchBox">
            <div @click="showMore" class="showMoreBtn">
                <i class="iconfont icon-you" v-bind:class="{'icon-shang': isShowMore}"></i>
                <span>{{$t('message.Search')}}</span>
            </div>
            <div v-show="isShowMore">
                <el-form :label-width="labelW" :model="ruleForm" ref="ruleForm">
                    <el-form-item :label="$t('message.KeyWord')" prop="KeyWord">
                        <el-input placeholder=" "
                                  v-model="ruleForm.KeyWord"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.InvoiceType')" prop="InvoiceTypeCode">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.InvoiceTypeCode">
                            <el-option
                                    :key="index"
                                    :label="item.TypeDesc"
                                    :value="item.TypeCode"
                                    v-for="(item, index) in invoiceTypeOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('message.ConsumptionKind')" prop="ConsumptionKind">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.ConsumptionKind">
                            <el-option
                                    :key="index"
                                    :label="item.ItemContent"
                                    :value="item.ItemContent"
                                    v-for="(item, index) in consumptionKindOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('message.InvoiceDate')" prop="InvoiceDate">
                        <el-date-picker
                                end-placeholder=" "
                                range-separator="-"
                                start-placeholder=" "
                                type="daterange"
                                v-model="ruleForm.InvoiceDate"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('message.IsEdit')" prop="IsEdit">
                        <el-radio-group v-model="ruleForm.IsEdit">
                            <el-radio :label="1">{{$t('message.Yes')}}</el-radio>
                            <el-radio :label="0">{{$t('message.No')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('message.IsVerification')" prop="IsCheckTrue">
                        <el-radio-group v-model="ruleForm.IsCheckTrue">
                            <el-radio :label="1">{{$t('message.Yes')}}</el-radio>
                            <el-radio :label="0">{{$t('message.No')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('message.IsConsecutive')" prop="IsConsecutive">
                        <el-radio-group v-model="ruleForm.IsConsecutive">
                            <el-radio :label="1">{{$t('message.Yes')}}</el-radio>
                            <el-radio :label="0">{{$t('message.No')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('message.Amount')" prop="Amount">
                        <div class="amount">
                            <el-input placeholder=" "
                                      type="number"
                                      v-model="ruleForm.Amount.AmountStart"></el-input>
                            <span>~</span>
                            <el-input placeholder=" "
                                      type="number"
                                      v-model="ruleForm.Amount.AmountEnd"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="'发票状态'" prop="InvoiceStatus">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.InvoiceStatus">
                            <el-option
                                    :key="index"
                                    :label="item.Description"
                                    :value="item.Status"
                                    v-for="(item, index) in InvoiceStatusOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="button-line">
                        <el-form-item>
                            <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                                <el-button @click="submitForm('ruleForm')" class="icon iconfont icon-sousuo"
                                           type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip :content="$t('message.Reset')" class="item" effect="dark" placement="top">
                                <el-button @click="resetForm('ruleForm')"
                                           class="icon iconfont icon-zhongzhi"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="table_container" v-loading="isLoading">
            <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#f8f8f9', 'color': '#262626'}"
                    :height="tableHeight"
                    :max-height="tableHeight"
                    :row-key="row => row.index"
                    class="table_list table_border no_sort"
                    ref="multipleTable"
                    stripe>
                <el-table-column
                        :label="$t('message.InvoiceNumber')"
                        :min-width="tableW[0]"
                        prop="InvoiceNumber"
                        sortable>
                    <template slot-scope="scope">
                        <span @click="getDetail(scope.row.Id)" class="link">
                            {{scope.row.InvoiceNumber}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('message.ExpenseNumber')"
                        :min-width="tableW[1]"
                        prop="ExpenseNumber"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.EmployeeNo')"
                        :min-width="tableW[2]"
                        prop="EmployeeNo"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.ChineseName')"
                        :min-width="tableW[3]"
                        prop="ChineseName"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.ConsumptionKind')"
                        :min-width="tableW[4]"
                        prop="ConsumptionKind"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceType')"
                        :min-width="tableW[5]"
                        :show-overflow-tooltip="true"
                        prop="TypeDesc"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.BusinessName')"
                        :min-width="tableW[6]"
                        :show-overflow-tooltip="true"
                        prop="SellerName"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceDate')"
                        :min-width="tableW[7]"
                        prop="InvoiceDateStr"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.IsEdit')"
                        :min-width="tableW[8]"
                        prop="IsChangedStr"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.IsVerification')"
                        :min-width="tableW[9]"
                        prop="IsCheckTrueStr"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceStatus')"
                        :min-width="tableW[10]"
                        prop="InvoiceStatus"
                        sortable>
                    <template slot-scope="scope">
                        <span :class="{waite: scope.row.InvoiceStatus === 1}">
                            {{scope.row.InvoiceStatusDesc}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('message.Amount')"
                        :min-width="tableW[11]"
                        align="right"
                        prop="TotalAmount"
                        sortable>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :total="count"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        background
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {baseUrl} from "../config/env";
    import {GetConsumptionKind, GetInvoiceType, InvoiceSearch,GetInvoiceStatus} from "../api/apiRetrieval";
    import {getLocal} from "../config/mUtils";

    export default {
        name: 'retrieval',
        data() {
            return {
                baseUrl,
                labelW: 0 + 'px',
                showSearchMore: false,
                isShowMore: false,
                invoiceTypeOptions: [],
                consumptionKindOptions: [],
                InvoiceStatusOptions:[],
                ruleForm: {
                    KeyWord: '',
                    InvoiceTypeCode: '0',
                    ConsumptionKind: '',
                    InvoiceDate: ['', ''],
                    IsEdit: -1,
                    IsCheckTrue: -1,
                    IsConsecutive: -1,
                    Amount: {
                        AmountStart: '',
                        AmountEnd: ''
                    },
                    InvoiceStatus:''
                },
                tableHeight: 0,
                isLoading: false,
                tableData: [],
                offset: 1,
                limit: 10,
                count: 0,
                currentPage: 1,
                normalW: {
                    cn: ['120', '160', '110', '105', '95', '120', '200', '125', '70', '70', '70', '100'],
                    en: ['145', '160', '130', '80', '160', '125', '200', '120', '100', '95', '85', '100']
                },
                tableW: []
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.watchHeight();
            this.initData();
            this.resetLabelWidth();
        },
        mounted() {
            setTimeout(() => {
                let widowHeight = document.documentElement.clientHeight - 237;
                let h = document.getElementById('searchBox').clientHeight;
                this.tableHeight = widowHeight - h;
            }, 1);
        },
        computed: {
            canResetH() {
                return this.isShowMore;
            },
            langChange() {
                return this.$i18n.locale;
            }
        },
        watch: {
            canResetH() {
                setTimeout(() => {
                    let widowHeight = document.documentElement.clientHeight - 237;
                    let h = document.getElementById('searchBox').clientHeight;
                    this.tableHeight = widowHeight - h;
                }, 1);
            },
            langChange(val) {
                if (val) {
                    this.isShowMore = false;
                    this.resetLabelWidth();
                }
            }
        },
        methods: {
            watchHeight() {
                setTimeout(() => {
                    const that = this;
                    window.onresize = function temp() {
                        let widowHeight = document.documentElement.clientHeight - 237;
                        let h = document.getElementById('searchBox').clientHeight;
                        that.tableHeight = widowHeight - h;
                    };
                }, 1);
            },
            resetLabelWidth() {
                if (getLocal('language') === 'zh-CN') {
                    this.labelW = 100 + 'px';
                    this.tableW = this.normalW.cn;
                } else {
                    this.labelW = 125 + 'px';
                    this.tableW = this.normalW.en;
                }
            },
            showMore() {
                this.isShowMore = !this.isShowMore;
            },
            async initData() {
                try {
                    this.getInvoiceType();
                    this.getConsumptionKind();
                    // this.getInvoiceList();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取发票类型
            async getInvoiceType() {
                this.invoiceTypeOptions = [];
                try {
                    let data = await GetInvoiceType(
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.invoiceTypeOptions = data.data;
                    }
                    let data1 = await GetInvoiceStatus(
                        // getLocal('language')
                    );
                    if (data1.error_code === '0') {
                        this.InvoiceStatusOptions = data1.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 获取消费类型
            async getConsumptionKind() {
                this.consumptionKindOptions = [];
                try {
                    let data = await GetConsumptionKind(
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.consumptionKindOptions = data.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 获取我的发票列表
            async getInvoiceList() {
                this.isLoading = true;
                this.tableData = [];
                try {
                    let data = await InvoiceSearch(
                        this.ruleForm.KeyWord,
                        this.ruleForm.InvoiceTypeCode,
                        this.ruleForm.ConsumptionKind,
                        this.ruleForm.Amount.AmountStart !== '' ? this.ruleForm.Amount.AmountStart : -1,
                        this.ruleForm.Amount.AmountEnd !== '' ? this.ruleForm.Amount.AmountEnd : -1,
                        this.ruleForm.InvoiceDate[0],
                        this.ruleForm.InvoiceDate[1],
                        parseInt(this.ruleForm.IsEdit),
                        parseInt(this.ruleForm.IsCheckTrue),
                        parseInt(this.ruleForm.IsConsecutive),
                        this.offset,
                        this.limit,
                        getLocal('language'),
                        this.ruleForm.InvoiceStatus
                    );
                    if (data.error_code === '0') {
                        this.isLoading = false;
                        this.count = data.data.TotalCount;
                        data.data.returnList.forEach(ele => {
                            this.tableData.push(ele);
                        });
                    } else {
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 更改每页显示数据条数
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.offset = 1;
                this.getInvoiceList();
            },
            // 更改当前页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.offset = val;
                this.getInvoiceList();
            },
            // 搜索
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getInvoiceList();
                    } else {
                        return false;
                    }
                });
            },
            // 重置
            resetForm(formName) {
                this.ruleForm.CreateTime = ['', ''];
                this.$refs[formName].resetFields();
                this.offset = 0;
                this.currentPage = 1;
                this.getInvoiceList();
            },
            // 进入详情
            getDetail(Id) {
                this.$router.push('/retrievalDetail?Id=' + Id)
            }
        }
    }
</script>

<style scoped>

</style>
